var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import SimplePanel from '@/shared/components/SimplePanel';
import messages from '@/modules/tasks/weekplanner/weekPlannerMessages';
import { useIntl } from 'react-intl';
import { FilterUserSearch } from '@/shared/components/input/filterInputs/FilterUserSearch';
import { FilterStatusSelect } from '@/shared/components/input/filterInputs/FilterStatusSelect';
import { FilterTaskTemplateMultiSelect } from '@/shared/components/input/filterInputs/FilterTaskTemplateMultiSelect';
import { FilterDelayedWeekPicker, } from '@/shared/components/input/filterInputs/FilterDelayedDateRangePicker';
import { FilterWrapper } from '@/shared/components/FilterWrapper';
import { WeekPlannerFilterType } from '../constants';
import AuthService from '@/shared/services/AuthService';
export var WeekPlannerHeader = function (_a) {
    var activeFilters = _a.activeFilters, defaultFilters = _a.defaultFilters, setFilter = _a.setFilter;
    var formatMessage = useIntl().formatMessage;
    var resetFilters = function () { return setFilter(defaultFilters); };
    var hasActiveFilters = function () {
        var _a;
        return !!activeFilters.status ||
            ((_a = activeFilters.taskTemplates) === null || _a === void 0 ? void 0 : _a.length) > 0 ||
            activeFilters.userId !== AuthService.getUserId() ||
            activeFilters.executionDateFrom !== defaultFilters.executionDateFrom ||
            activeFilters.executionDateUntil !== defaultFilters.executionDateUntil;
    };
    return (_jsx(SimplePanel, __assign({ article: "22681112356124", title: formatMessage(messages.WeekPlanner), buttons: [] }, { children: _jsx("div", __assign({ className: "info-block container-fluid" }, { children: _jsx(FilterWrapper, __assign({ filterObject: activeFilters, setFilter: setFilter, hasActiveFilters: hasActiveFilters, resetFilters: resetFilters, screen: "WeekPlanner", invisibleFilters: [] }, { children: [
                    FilterUserSearch({
                        item: WeekPlannerFilterType.userId,
                        label: formatMessage(messages.ForEmployee),
                        isAlwaysVisible: true,
                        withUnassigned: false,
                        setFilter: setFilter,
                        activeFilters: activeFilters,
                        enabled: true,
                    }),
                    FilterTaskTemplateMultiSelect({
                        item: WeekPlannerFilterType.taskTemplates,
                        label: formatMessage(messages.SelectTask),
                        isAlwaysVisible: true,
                        setFilter: setFilter,
                        activeFilters: activeFilters,
                        enabled: true,
                    }),
                    FilterStatusSelect({
                        item: WeekPlannerFilterType.status,
                        label: formatMessage(messages.Status),
                        isAlwaysVisible: true,
                        setFilter: setFilter,
                        activeFilters: activeFilters,
                        enabled: true,
                    }),
                    FilterDelayedWeekPicker({
                        startDateItem: WeekPlannerFilterType.executionDateFrom,
                        endDateItem: WeekPlannerFilterType.executionDateUntil,
                        startDateId: 'ExecutionDateStartFilter',
                        endDateId: 'ExecutionDateEndFilter',
                        startDatePlaceholder: formatMessage(messages.ExecutionDateFrom),
                        endDatePlaceholder: formatMessage(messages.ExecutionDateUntil),
                        setFilter: setFilter,
                        activeFilters: activeFilters,
                        enabled: true,
                        isWeekPicker: true,
                        required: true,
                    }),
                ] })) })) })));
};
